var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.098,
    height: 13.818,
    viewBox: "0 0 20.098 13.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.842,80H1.256A1.257,1.257,0,0,0,0,81.256v.715l10.049,4.256L20.1,81.97v-.713A1.257,1.257,0,0,0,18.842,80Z",
    transform: "translate(0 -80)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.336)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.294,169.111a.622.622,0,0,1-.49,0L0,164.96v9.226a1.257,1.257,0,0,0,1.256,1.256H18.842a1.257,1.257,0,0,0,1.256-1.256V164.96Z",
    transform: "translate(0 -164.96)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEmail);
export default __webpack_public_path__ + "static/media/ico-email.947ff5e5.svg";
export { ForwardRef as ReactComponent };